/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const globalFilterTokens = {
  PanelBorderRadiusBaseDefault: '4px',
  PanelBorderStyleBaseDefault: 'solid',
  PanelBorderWidthBaseDefault: '1px',
  PanelBorderColorBaseDefault: '#dedfdf',
  PanelMarginTopBaseDefault: '4px',
  PanelElevationBaseDefault: '1100',
  MenuBackgroundColorBaseDefault: '#fbf8f7',
  ViewBackgroundColorBaseDefault: '#ffffff',
  ViewPaddingVerticalBaseDefault: '16px',
  ViewPaddingHorizontalBaseDefault: '16px',
  ToolbarGapBaseDefault: '8px',
} as const;
